import styled from 'styled-components'

// Note: `.ctp-rewards__inner` (the legacy Rewards tab shell this page renders into) only
// stretches to fill the available height when it contains this section's `#gift-cards-page-table`
// id - see rewards.scss. Without it, the table just grows to its content height and leaks into
// page-level scroll instead of scrolling internally.
export const TableSection = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: 0,
})
